import { Box } from '@wix/design-system';
import {
  useProductHat,
  useSelectButton,
} from '@wix/package-picker-shared-eclipse';
import { SocialProofHat } from '../ProductCards/ProductCard/SocialProofHat';
import { FeaturesGrid as PlatformFeaturesGrid } from '@wix/premium-purchase-platform/@components';
import React from 'react';
import { EclipsePackagePickerModule } from '../../modules/eclipse-package-picker.module';
import { EclipsePrice } from '../EclipsePrice/EclipsePrice';
import s from './FeaturesGrid.scss';

interface FeaturesGridProductHeaderProps {
  productId: string;
}

export const FeaturesGridProductHeader = ({
  productId,
}: FeaturesGridProductHeaderProps) => {
  const { t } = EclipsePackagePickerModule.internals.useTranslations();
  const { experiments } = EclipsePackagePickerModule.internals.experiments.hooks.useExperiments();
  const isSocialProofEnabled = experiments.isEnabled('specs.premium.EclipseDesktopSocialProof');
  const { ProductHat } = useProductHat({ productId });
  const { data: product, isLoading } =
    EclipsePackagePickerModule.SDK.eclipseOfferingApiClient.hooks.useFetchProduct(
      {
        productId,
      },
    );

  const { SelectButton } = useSelectButton({ productId });

  const { isRecommended, isEnterprise, name, hasSale } = product ?? {};

  if (isLoading) {
    return null;
  }

  const backgroundGradient = isRecommended
    ? 'linear-gradient(180deg, #FFF 0%, #FAF9FF 100%)'
    : 'white';

  return (
    <PlatformFeaturesGrid.Header.Cell
      gap="SP1"
      background={backgroundGradient}
      border="none"
      marginTop="-28px"
    >
      <Box
        padding={isSocialProofEnabled && isRecommended && !hasSale ? '0' : '0 SP1'}
        boxSizing="border-box"
      >
        {isSocialProofEnabled && isRecommended && !hasSale ? (
          <SocialProofHat
            text={t('premium-purchase-plan.eclipse.table.hat.social-proof')}
            border="1px solid var(--eclipse-bg-color)"
            borderRadius="4px"
            paddingY="8px"
          />
        ) : (
          <ProductHat height="26px" />
        )}
      </Box>
      <Box align="center" marginTop="SP2">
        <PlatformFeaturesGrid.Header.Title
          title={name ?? ''}
          size="small"
          className={s.gridPlanTitle}
          dataHook={`grid-plan-title-${productId}`}
        />
      </Box>
      <Box visibility={isEnterprise ? 'hidden' : 'visible'} align="center">
        <EclipsePrice productId={productId} />
      </Box>
      <Box align="center" width="100%" marginBottom="SP3" marginTop="SP1">
        <Box align="center" width="126px" marginBottom="SP3" marginTop="SP1">
          <SelectButton
            variant={isRecommended ? 'primary' : 'secondary'}
            size="medium"
            fullWidth
          />
        </Box>
      </Box>
    </PlatformFeaturesGrid.Header.Cell>
  );
};
